"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandMeasures = exports.calculateMeasureVolume = exports.calculatePileVolume = exports.getPileFactor = exports.CONVERSION_FACTORS = void 0;
const util_1 = require("./util");
exports.CONVERSION_FACTORS = {
    "8": 1.3,
    "9": 1.6,
    "10": 1.8,
    "16": 3.0,
    "17": 3.1,
    "18": 3.2,
    "21": 3.4
};
function getPileFactor(pile) {
    const { measures } = pile;
    if (!measures)
        return null;
    const { logLength } = measures;
    if (!logLength)
        return null;
    const key = String(logLength);
    return exports.CONVERSION_FACTORS[key];
}
exports.getPileFactor = getPileFactor;
function calculatePileVolume(p) {
    const factor = getPileFactor(p);
    if (!factor)
        return null;
    return p.height * p.length * factor;
}
exports.calculatePileVolume = calculatePileVolume;
function calculateMeasureVolume(m) {
    const key = String(m.logLength);
    const factor = exports.CONVERSION_FACTORS[key] || 0;
    return m.heights.reduce(util_1.sum, 0) / m.heights.length * m.length * factor;
}
exports.calculateMeasureVolume = calculateMeasureVolume;
function expandMeasures(m) {
    let { length, heights, logLength } = m;
    if (heights.length == 0) {
        heights = [0];
    }
    const height = heights.reduce(util_1.sum, 0) / heights.length;
    const volume = calculateMeasureVolume(m);
    return { length, logLength, height: Number(height.toFixed(2)), volume: volume || 0 };
}
exports.expandMeasures = expandMeasures;
